import React, { useEffect, useState } from "react";
import { Form, Button, Divider, Row, Col, Select } from "antd";
import classes from "../AddActivities.module.scss";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Header from "../../../../Components/Header/Header";
import ButtonActions from "../../../../Components/Buttons/ButtonActions/ButtonActions";

const AddActivitiesPage2 = ({
  backPage,
  finalizeRegister,
  gameData,
  updatedGameDate,
  gamesMapField,
}) => {
  const [optionElaboration, setOptionElaboration] = useState([]);
  const [optionDevelopment, setOptionDevelopment] = useState([]);
  const [optionIllustration, setOptionIllustration] = useState([]);
  const [infos, setInfos] = useState({});
  const [content, setContent] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [editorValue, setEditorValue] = useState("");
  const [showHTML, setShowHTML] = useState(false);

  // [Função] Alterna entre editor e visualização HTML
  const toggleHTML = () => {
    setShowHTML(!showHTML);
  };

  // Configuração da barra de ferramentas do editor de texto (Quill)
  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        ["link", "image", "video"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["clean"],
      ],
    },
  };

  // Formatos permitidos no conteúdo do editor
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
    "image",
    "video",
  ];

  //[Efeito] Executa esse código sempre que a variável 'gamesMapField' for alterada.
  useEffect(() => {
    // Verifica se os dados existem; se sim, preenche as opções
    if (gamesMapField) {
      setOptionElaboration(
        gamesMapField["credits"]?.elaboration?.map((ability) => ({
          label: ability,
          value: ability,
        })),
      );
      setOptionDevelopment(
        gamesMapField["credits"]?.development?.map((ability) => ({
          label: ability,
          value: ability,
        })),
      );
      setOptionIllustration(
        gamesMapField["credits"]?.illustration?.map((ability) => ({
          label: ability,
          value: ability,
        })),
      );
    }
  }, [gamesMapField]);

  // console.log(gameData);

  // Atualiza o campo 'infos' do jogo sempre que o conteúdo do editor mudar
  useEffect(() => {
    if (editorValue) {
      updatedGameDate(["infos"], editorValue);
    }
  }, [editorValue]);

  // Atualiza o conteúdo do editor com base em gameData.infos
  useEffect(() => {
    if (gameData.infos && typeof gameData.infos === "string") {
      // Se for uma string simples, usa diretamente
      setEditorValue(gameData.infos);
    } else if (gameData?.infos?.length && gameData?.infos[0]?.body) {
      // Se for um array de objetos com 'body', usa o primeiro
      setEditorValue(gameData.infos[0].body);
    } else if (gameData.infos && gameData.infos[0] && gameData.infos[0][0]) {
      // Se for um array de arrays, acessa o primeiro elemento do primeiro array
      setEditorValue(gameData.infos[0][0].body);
    } else {
      // Caso contrário, define como texto vazio
      setEditorValue("");
    }
  }, [gameData]);

  //Função para voltar para página inicial
  const handleCancel = () => {
    backPage();
  };

  // Função chamada ao finalizar o cadastro
  const handleFinalizeRegistration = () => {
    console.log("Finalizando o cadastro...");
    // Desativa o botão para evitar múltiplos envios
    setButtonDisable(true);
    console.log(
      "Chamada para desabilitar o botão. Valor de buttonDisable:",
      true,
    );
    finalizeRegister();
  };

  //Estilo das labels
  const labelStyle = {
    color: "#3C3C3C",
    fontSize: "16px",
    fontWeight: "500",
  };

  //Estilo dos inputs
  const inputStyle = {
    width: "100%",
    height: "120px",
  };

  // Variável de estilo para a tooltip
  const tooltipStyle = ` 
    .ql-tooltip {
      position: absolute !important;
      left: 10% !important;
      top: -40px !important;
      max-width: calc(100% - 20px) !important;
      transform: none !important;
      white-space: nowrap;
    }

    @media (max-width: 768px) {
      .ql-tooltip {
      left: 5% !important; 
      top: -30px !important;
    }
  }`;

  const editTextArea = (value) => {
    setEditorValue(value.target.value);
  };

  useEffect(() => {
    setContent(
      <>
        <Header text="Cadastrar Atividade" />
        <Form
          size="large"
          layout="vertical"
          labelCol={{ span: 12 }}
          wrapperCol={{ span: 16 }}
        >
          <h3
            style={{
              color: "#0A4148",
              fontSize: "20px",
              fontWeight: "500",
              marginBottom: "20px",
            }}
          >
            Informações adicionais{" "}
          </h3>
          <Row style={{ marginBottom: 10 }}>
            <Col xs={24} sm={12} md={8} lg={6}>
              <Button
                onClick={() => toggleHTML()}
                type="primary"
                className={classes.editorInfoButton}
              >
                {showHTML ? "Voltar para Editor" : "Ver HTML"}
              </Button>
            </Col>
          </Row>
          {showHTML ? (
            <textarea
              onChange={editTextArea}
              value={editorValue}
              rows={10}
              cols={50}
              style={{
                width: "100%",
                fontFamily: "monospace",
                display: showHTML ? "block" : "none",
              }}
            ></textarea>
          ) : (
            <div
              style={{
                maxWidth: "100%",
                display: showHTML ? "none" : "block",
              }}
            >
              <ReactQuill
                value={editorValue}
                onChange={setEditorValue}
                theme="snow"
                modules={modules}
                formats={formats}
                style={{ width: "100%" }}
              />
              <style>{tooltipStyle}</style>
            </div>
          )}

          <Divider style={{ borderWidth: "4px" }} />
          <h3
            style={{
              color: "#0A4148",
              fontSize: "20px",
              fontWeight: "500",
              marginBottom: "20px",
            }}
          >
            Créditos
          </h3>

          <Row gutter={[16, 16]}>
            <Col xs={24} sm={8}>
              <Form.Item
                label={<span style={labelStyle}>Elaboração</span>}
                name="elaboration"
              >
                <Select
                  placeholder="Selecionar"
                  mode="tags"
                  tokenSeparators={[","]}
                  style={inputStyle}
                  options={optionElaboration}
                  defaultValue={gameData["credits"]?.elaboration || []}
                  onChange={(event) => {
                    updatedGameDate("credits", {
                      ...gameData["credits"],
                      elaboration: event,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                label={<span style={labelStyle}>Desenvolvimento</span>}
                name="development"
              >
                <Select
                  placeholder="Selecionar"
                  mode="tags"
                  tokenSeparators={[","]}
                  style={inputStyle}
                  options={optionDevelopment}
                  defaultValue={gameData["credits"]?.development || []}
                  onChange={(event) => {
                    updatedGameDate("credits", {
                      ...gameData["credits"],
                      development: event,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={8}>
              <Form.Item
                label={<span style={labelStyle}>Ilustração</span>}
                name="illustration"
              >
                <Select
                  placeholder="Selecionar"
                  mode="tags"
                  tokenSeparators={[","]}
                  style={inputStyle}
                  options={optionIllustration}
                  defaultValue={gameData["credits"]?.illustration || []}
                  onChange={(event) => {
                    updatedGameDate("credits", {
                      ...gameData["credits"],
                      illustration: event,
                    });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <div className={classes.buttonContainer}>
              <ButtonActions
                variant="outline"
                onClick={handleCancel}
                text="Voltar"
              />
              <ButtonActions
                variant="primary"
                onClick={handleFinalizeRegistration}
                disabled={buttonDisable}
                text="Finalizar cadastro"
              />
            </div>
          </Form.Item>
        </Form>
      </>,
    );
  }, [infos, editorValue, showHTML, buttonDisable]);

  return <>{content}</>;
};

export default AddActivitiesPage2;
